import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/recharge.vue')
  },
  {
    path: '/dosage_details',
    name: 'Dosage_details',
    component: () => import('../views/dosage_details.vue')
  },
  {
    path: '/billing_record',
    name: 'Billing_record',
    component: () => import('../views/billing_record.vue')
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('../views/notice.vue')
  },
  {
    path: '/details',
    name: 'Details',
    component: () => import('../views/details.vue')
  },
  {
    path: '/empower',
    name: 'Empower',
    component: () => import('../views/empower.vue')
  },
  {
    path: '/refund',
    name: 'Refund',
    component: () => import('../views/refund.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',//路由基路径
  routes
})

export default router
